import api from '../../api'
import { getVisibility } from '../../utils'
import { collectionSubAdapter } from '../collection/adapter'
import dayjs from 'dayjs'
import 'dayjs/locale/en'
import 'dayjs/locale/id'
import systemAdapter from '../system/adapter'

const EXTERNAL_LINK_ID = 1

const adapter = {
  responseBodyToRender(input){
    let output = {}

    if(input){
      const {
        artikelId,
        resourceId,
        datePublish,
        kategoriArtikel,
        imgThumbnail,
        imgMainImage,
        myOrganisasi,
        judulArtikel,
        deskripsiPendek,
        resourcesFiles = {},
        typeApproach = [],
        typeAudience = [],
        typeIssues = [],
        totalLikes,
        totalBookmarks,
        submission,
        listLike = [],
        listBookmark = [],
        likedByMe,
        bookmarkByMe,
        resourcesTag: tag = []
      } = input

      function getChildData(){
        if(resourcesFiles !== null){
          const {
            pkFileId,
            binFile,
            typeResources,
            embedLink
          } = resourcesFiles

          const getUrl = (binFile) => {
            const defaultFile = '/assets/file.pdf'
            const defaultEmbed = 'https://'
            let url = api.base_image + binFile

            // PeaceGen's request: external link = not embed
            const is_external = typeResources === EXTERNAL_LINK_ID
            const is_embed = is_external ? false
            : (
              binFile === defaultFile
              && embedLink !== defaultEmbed
            )

            if(is_embed){
              url = embedLink
            }

            return {url, is_embed, is_external}
          }

          return {
            fileId: pkFileId,
            url: getUrl(binFile).url,
            is_embed: getUrl(binFile).is_embed,
            is_external: getUrl(binFile).is_external,
            embedLink,
            type: typeResources,
          }
        }

        return {}
      }

      let category = {
        en: 'uncategorized',
        id: 'uncategorized'
      }

      if(kategoriArtikel && kategoriArtikel[0] && kategoriArtikel[0].nama){
        category = {
          en: kategoriArtikel[0].nama[1],
          id: kategoriArtikel[0].nama[0]
        }
      }

      const organization_id = myOrganisasi ? myOrganisasi.organisasiId : undefined
      const organization = myOrganisasi ? myOrganisasi.namaOrganisasi : 'Default'
      const organization_logo = myOrganisasi ? myOrganisasi.imgLogoOrganisasi : undefined

      const visibility_field_blacklist = ['vsbDeskripsiPendek', 'vsbTag', 'vsbTbFiles', 'vsbTbGalleries', 'vsbComments']
      const visibility_id_only = getVisibility(input, visibility_field_blacklist).visibilityIdOnly
      const is_all_public = getVisibility(input).isAllPublic
      const is_private = getVisibility(input).isPrivate

      let special = false
      if(tag.length > 0){
        for (let index = 0; index < tag.length; index++) {
          const element = tag[index];

          const {
            pilihanTagId = {}
          } = element

          if(
            pilihanTagId &&
            pilihanTagId.nama &&
            pilihanTagId.nama[0]
          ){
            const { nama = [] } = pilihanTagId
            if(
            nama[0].toLowerCase().includes('special')
            || nama[1].toLowerCase().includes('special')
            || nama[0].toLowerCase().includes('spesial')
            || nama[1].toLowerCase().includes('spesial') ){
              special = true
            }
          }
        }
      }

      output = {
        id: resourceId ? resourceId : artikelId,
        is_all_public,
        is_private,
        published: datePublish,
        date_by_language: {
          en: dayjs(datePublish).locale('en').format('LLLL'),
          id: dayjs(datePublish).locale('id').format('llll'),
        },
        image: api.base_image + imgMainImage,
        thumbnail: api.base_image + imgThumbnail,
        category,
        categories_rendered: systemAdapter.responseBodyArrayToBilingualObject(kategoriArtikel),
        organization_id,
        organization,
        organization_logo: api.base_image + organization_logo,
        title: {
          id: judulArtikel ? judulArtikel[0] : '-',
          en: judulArtikel ? judulArtikel[1] : '-',
        },
        special,
        featured: false,
        excerpt: {
          id: deskripsiPendek ? deskripsiPendek[0] : '-',
          en: deskripsiPendek ? deskripsiPendek[1] : '-',
        },
        content: {
          id: deskripsiPendek ? deskripsiPendek[0] : '-',
          en: deskripsiPendek ? deskripsiPendek[1] : '-',
        },
        audiences: renderSystemType(typeAudience),
        approaches: renderSystemType(typeApproach),
        issues: renderSystemType(typeIssues),
        approach_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeApproach),
        issue_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeIssues),
        audience_rendered: systemAdapter.responseBodyArrayToBilingualObject(typeAudience),

        total_likes: totalLikes,
        total_bookmarks: totalBookmarks,
        submission,
        likes: listLike.map(l => collectionSubAdapter.like.responseBodyToRender(l)),
        bookmarks: listBookmark.map(l => collectionSubAdapter.like.responseBodyToRender(l)),

        visibility_id_only,

        liked: likedByMe,
        bookmarked: bookmarkByMe,

        ...getChildData()
      };
    }

    return output
  }
}

function renderSystemType(typeData){
  return typeData ? typeData.map(d => {
    const {id, nama} = d
    return {
      id,
      name: {
        en: nama?.[1],
        id: nama?.[0]
      }
    }
  }) : []
}

export default adapter
